<template>
    <div class="live flex">
        <!-- 直播模块 -->
        <div ref="liveArea" class="live-area flex-item">
            <!-- 视频区 -->
            <div id="playbackPlayer"></div>
            <!-- 提示 -->
            <div
                v-if="showTip"
                class="live-tip flex flex-column flex-item flex-vertical-center flex-center"
            >
                <img class="live-tip-img" src="@images//player/not-play.png" />
                <div class="live-tip-text">{{ tipInfo }}</div>
            </div>
        </div>
        <aside class="live-aside flex flex-column">
            <!-- 直播简介 -->
            <div class="live-intro">
                <h2 class="live-title">{{ video.name }}</h2>
                <div class="live-text">
                    授课老师：{{ video.teacher_name }} / 科目：【 {{ video.subject_name }} 】
                </div>
                <!-- <div class="live-text">{{ video.show_time }}</div> -->
                <div v-if="video.work_id">
                    <hk-button
                        v-if="video.work_status"
                        :height="34"
                        text="作业解析"
                        :customStyle="analysisButton"
                        @handleClick="handleToTestAnalysis"
                    ></hk-button>
                    <hk-button
                        v-else
                        :height="34"
                        text="做作业"
                        :customStyle="replayButton"
                        @handleClick="handleToTest"
                    ></hk-button>
                </div>
            </div>
            <!-- 工具栏 -->
            <div class="live-tools flex flex-item flex-column">
                <resource-area :resourceList="resourceList" />
            </div>
        </aside>
    </div>
</template>

<script>
import playIcon from '@images/player/play.png';
import pauseIcon from '@images/player/pause.png';
import fullscreenIcon from '@images/player/fullscreen.png';
import { initAliPlayerSDKLoader } from '@plugins/_live';
import ResourceArea from './ResourceArea.vue';
import { getAliPlayAuth } from '@api/player';
import HkButton from '@components/HkButton.vue';

const icons = {
    prepare: playIcon,
    play: pauseIcon,
    pause: playIcon,
    terminate: playIcon,
    fullscreen: fullscreenIcon
};
export default {
    name: 'PlaybackPlayer',
    components: { ResourceArea, HkButton },
    props: {
        /**
         * 视频信息
         */
        video: Object
    },
    data() {
        return {
            analysisButton: {
                width: '280px',
                color: '#BEBEBF',
                border: '1px solid #6F6F73',
                shadowColor: 'transparent',
                background: true,
                startColor: 'transparent',
                endColor: 'transparent'
            },
            replayButton: {
                width: '280px',
                color: '#fff',
                shadowColor: 'transparent',
                background: true,
                startColor: '#A90FBC',
                endColor: '#CA2AD0'
            },
            icons: Object.freeze(icons),
            /**
             * type //直播间模板类型  （1:大屏模式 ，2：问答、视频、聊天 ，3：视频、聊天，4：文档、视频。聊天，5：视频、文档、问答、聊天，6：视频、问答
             */
            template: null,
            viewer: null,
            liveTime: '2020-11-05',
            activeName: 'resource',
            timer: null,
            /**
             * 直播状态  prepare: 准备、play：播放、pause：暂停、terminate：终止（当前项目没有pause暂停）
             */
            liveStatus: 'prepare',
            /**
             * 显示控制条
             */
            showControl: true,
            /**
             * 全屏
             */
            fullscreen: false,
            /**
             * 音量
             */
            sound: 0
        };
    },
    computed: {
        showTip() {
            return ['terminate', 'prepare', 'unauthorized'].includes(this.liveStatus);
        },
        tipInfo() {
            let tip = '';
            switch (this.liveStatus) {
                case 'play':
                    tip = '正在播放~';
                    break;
                case 'pause':
                    tip = '暂停播放~';
                    break;
                case 'terminate':
                    tip = '播放完成~';
                    break;
                case 'unauthorized':
                    tip = '对不起，尚未获取到授权，请刷新重试~';
                    break;
                default:
                    tip = '回看正在生成，请稍后~';
                    break;
            }
            return tip;
        },
        resourceList() {
            const { video } = this;
            return video.file
                ? [
                      {
                          name: '课程资料',
                          id: video.id
                      }
                  ]
                : [];
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        /**
         * 测试分析
         */
        handleToTestAnalysis() {
            this.$trackEvent('答题', '解析', this.$route.query.id);
            this.$router.push({
                name: 'Analysis',
                query: { scheduleId: this.$route.query.id }
            });
        },
        /**
         * 测试
         */
        handleToTest() {
            this.$trackEvent('答题', '开始做题', this.$route.query.id);
            this.$router.push({
                name: 'Test',
                query: { scheduleId: this.$route.query.id }
            });
        },
        async init() {
            await this.$nextTick();
            this.liveStatus = 'prepare';
            const AliPlayer = await initAliPlayerSDKLoader();
            const videoId = this.video.video_id;
            if (!videoId) {
                return false;
            }
            const options = await this.getOptions(videoId);
            const player = new AliPlayer({
                ...options,
                width: '100%',
                height: '100%',
                id: 'playbackPlayer'
            });
            this.liveStatus = 'play';
            this.player = player;
            this.$emit('hook:beforeDestroy', this.destroyPlayer);
        },
        destroyPlayer() {
            if (this.player) {
                this.player.dispose();
            }
        },
        async getOptions(videoId) {
            const { data } = await getAliPlayAuth(videoId);
            const { PlayAuth, VideoMeta } = data;
            const options = {
                autoplay: true,
                cover: VideoMeta.CoverURL,
                vid: VideoMeta.VideoId,
                playauth: PlayAuth,
                encryptType: 1 // 当播放私有加密流时需要设置。
            };
            return options;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@stylesheets/_aliplayer';

.live-player {
    position: absolute;
    width: 100%;
    height: 100%;
    &-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 98;
    }
}
#playbackPlayer {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.live {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #30343f;
    overflow: hidden;
    &-area {
        position: relative;
    }
    &-controls {
        z-index: 999;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 44px;
        &-bar {
            height: 44px;
            background: #27282a;
            opacity: 0.9;
            color: #ffffff;
            font-weight: 500;
            padding: 0 10px;
            transform: translateY(44px);
            transition: all 300ms ease-in;
        }
        &:hover {
            .live-controls-bar {
                transform: translateY(0) !important;
            }
        }
        &::v-deep {
            .el-progress-bar__outer {
                background-color: #1e1e1e;
                border-radius: 10px;
                overflow: hidden;
                cursor: pointer;
            }
            .el-progress-bar__inner {
                background-color: #404040;
                cursor: pointer;
            }
            .el-progress-bar__innerText {
                display: none;
            }
        }
    }
    &-tip {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
        &-img {
            width: 226px;
            height: 115px;
            object-fit: contain;
        }
        &-text {
            font-size: 32px;
            color: #ffffff;
            margin-top: 32px;
            text-align: center;
        }
    }
    &-container {
        position: absolute;
        top: 60px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }
    &-aside {
        width: 310px;
        height: 100%;
        background-color: #333335;
    }
    &-intro {
        padding: 7px 15px 9px;
        color: #666666;
    }
    &-title {
        font-size: 18px;
        color: #ffffff;
        margin: 12px 0;
    }
    &-text {
        margin: 11px 0;
    }
    &-tools {
        height: calc(100vh - 373px);
        &::v-deep {
            .el-tabs__nav {
                width: 100%;
                // display: flex
            }
            .el-tabs__item {
                color: #707074;
                font-weight: 500;
                padding: 0;
            }
            .el-tabs__nav-wrap {
                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                }
                &::after,
                &::before {
                    height: 1px;
                    background: #545454;
                }
            }
            .el-tabs__active-bar {
                width: 3em !important;
                margin-left: calc(25% - 1.5em);
                height: 3px;
                background: #c1c1c2;
            }
            .el-tabs__content {
                flex: 1;
            }
        }
    }
}
.tool-icon {
    cursor: pointer;
}
.tool-item {
    & + & {
        margin-left: 16px;
    }
}
.tab-panel {
    height: 100%;
}
.first-screen {
    position: relative;
}
.second-screen {
    width: 310px;
    height: 199px;
    background-color: #2b2b2d;
}
.doc-aside {
    position: absolute !important;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 998;
}
</style>
